import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import IResponse = ZoneIQCalibration.IResponse;
import IZoneCombination = ZoneIQCalibration.IZoneCombination;
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { BaseAPIService } from './base-api.service';

const API = environment.ZONEIQ_CALIBRATION + '/v1/zone-combination';

@Injectable({
    providedIn: 'root'
})
export class ZoneCombinationService extends BaseAPIService {
    constructor(private readonly http: HttpClient) {
        super();
    }

    saveChanges(zoneCombinations: IZoneCombination[]): Observable<IResponse> {
        if (!_.get(zoneCombinations, 'length', 0)) {
            return;
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams().set('syncChanges', 'true');

        return this.http.post<IResponse>(`${API}?getNames=true`, zoneCombinations, { headers, params });
    }

    replaceZoneCombinationINCRs(zoneCombination: IZoneCombination): Observable<IResponse> {
        if (!_.get(zoneCombination, 'Id')) {
            return of(null);
        }

        const incReasonsIds = zoneCombination.IsNotCalibrated
            ? (zoneCombination.IsNotCalibratedReason || []).map(reason => reason.Id)
            : [];

        return this.http.post<IResponse>(`${API}/${zoneCombination.Id}/is-not-calibrated-reasons`, { incReasonsIds });
    }


}
